import React from 'react';
import Table from './Table';

const TableComponent = ({ record }) => {
  return <Table classes={record?.classes || []} />;
};

export default TableComponent;
